import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectMaker
 */
class SelectMaker extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      maker: this.props.data.maker,
      masterList: []
    };
    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  /**
   * メーカー選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.makerIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_maker_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: this.props.data.itemList.makerList });
      $('#modal_maker_select_panel').show();
    }
  }

  render() {
    let SelectModalPanelNodes = null;
    if (this.state.masterList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'メーカー'}
          allCheckText={'すべてのメーカー'}
          checkedList={this.props.data.makerIds}
          idKey={'id'}
          valueKey={'display_name'}
        />
      );
    }

    return (
      <div>
        <div className="ctrl_form_title controlForm__title--state_enable controlForm__text--state_enable">
          <p>メーカー</p>
        </div>
        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectMaker" className="select_maker_content">
            <p>aaa</p>
          </div>
        </label>

        <div id="modal_maker_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>

        {/* メーカー選択画面 */}
        {/* <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'メーカー'}
          allCheckText={'すべてのメーカー'}
          checkedList={this.props.data.makerIds}
        /> */}
      </div>
    );
  }
}

SelectMaker.propTypes = {
  data: PropTypes.any.isRequired
};

export default SelectMaker;
